<template>
  <div>
    <VTableRemote
      :items="items"
      :headers="headersList"
      :pagination="pagination"
      :title="title"
      :iconHeader="iconHeader"
      :centerColumns="['action']"
      :notSortableColumns="notSortableColumns"
      :isSearchable="isSearchable"
      :disablePagination="true"
      :isInfinitScroll="true"
      :sortableColumns="sortableColumns"
      :hideDefaultFooter="hideDefaultFooter"
      @iconAction="onClickAction"
      @sendQueryParams="searchInputHandler"
    >
      <template #body>
        <draggable
          :list="items"
          :options="{disabled: disabled}"
          tag="tbody"
          @change="onDragChange"
        >
          <tr
            v-for="(item,index) in items"
            :key="index"
          >
            <template v-for="(headerN,indexN) in headersList">
              <td
                :key="`${index}_${indexN}_others`"
              >
                <div v-if="headerN.value==='displayOrder'">
                  <v-icon
                    large
                    class="hidden-md-and-down"
                    color="primary"
                  >
                    mdi-drag-vertical
                  </v-icon>
                  {{ item[headerN.value] }}
                </div>
                <div v-else-if="headerN.value==='componentTypes'">
                  <p class="data-p">
                    {{ item[headerN.value].join(', ') }}
                  </p>
                </div>
                <div v-else-if="headerN.value==='networkTypes'">
                  <p class="data-p">
                    {{ item[headerN.value].join(', ') }}
                  </p>
                </div>
                <div v-else-if="headerN.value==='procedure'">
                  <TableFiles :files="item[headerN.value]" />
                </div>
                <div
                  v-else-if="headerN.value==='actions'"
                >
                  <VTableAction
                    :itemActions="actions"
                    :verticalActionDots="true"
                    :isCustomIcon="isCustomIconNext"
                    @iconAction="(action)=>onClickAction(item, action)"
                  />
                </div>
                <div v-else>
                  {{ item[headerN.value] }}
                </div>
              </td>
            </template>
          </tr>
        </draggable>
      </template>
      <template #SearchWithFilters>
        <SearchWithFilters
          :filters="filters"
          :searchPlaceholder="$t('charts.searchBy')"
          :filterName="filterName"
          :saveFilter="true"
          @onApplyFilters="handleApplyFilters"
          @onSearch="handleSearch"
        />
      </template>
    </VTableRemote>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import VTableRemote from '@/components/shared/content-views/VTableRemote';
import VTableAction from '@/components/shared/widgets/VTableAction';
import TableFiles from '@/components/shared/content-views/slots/TableFiles';
import { mapGetters } from 'vuex';
import SearchWithFilters from '@/components/shared/SearchWithFilters.vue';

export default {
    components: {
        SearchWithFilters,
        VTableRemote,
        draggable,
        VTableAction,
        TableFiles,
    },
    props: {
        items: {
            type: Array,
            required: true,
        },
        headers: {
            type: Array,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        isCustomIconNext: {
            type: Boolean,
            default: false,
        },
        isSearchable: {
            type: Boolean,
            default: false,
        },
        pagination: {
            type: Object,
            default: () => {},
        },
        title: {
            type: String,
            default: '',
        },
        actions: {
            type: Array,
            default: () => [],
        },
        iconHeader: {
            type: String,
            default: '',
        },
        hideDefaultFooter: {
            type: Boolean,
            default: false,
        },
        filterName: {
            type: String,
            default: '',
        },
        filters: {
            type: Array,
            default: () => [],
        },
        handleSearch: {
            type: Function,
            default: () => {},
        },
        handleApplyFilters: {
            type: Function,
            default: () => {},
        },
        sortableColumns: {
            type: Array,
            default: () => [],
        },
        notSortableColumns: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            search: null,
        };
    },
    computed: {
        ...mapGetters([
            'hasPermission',
        ]),
        headersList() {
            const headerAction = [{ text: this.$t('forms.labels.actions'), value: 'actions' }];
            return this.actions.length ? [...this.headers, ...headerAction] : [...this.headers];
        },

    },
    methods: {
        onDragChange(e) {
            const payload = { newIndex: e.moved.newIndex, activityId: e.moved.element.id };
            this.$emit('change', payload);
        },
        onClickAction(item, action) {
            this.$emit('onClickAction', item, action);
        },
        searchInputHandler(queryParams) {
            this.$emit('sendQueryParams', queryParams);
        },
    },
};

</script>

<style lang="scss" scoped>
.data-p {
    margin-bottom: 0;
}
</style>
